import { AgGridColors, agGridColors } from './agGridColors';
import { PaletteColors, paletteColors } from './paletteColors';
import dark from './darkColors';
import light from './lightColors';

export type AllColors = ThemeColors & PaletteColors & { agGrid: AgGridColors };

export interface ThemeColors {
  primary: string;
  secondary: string;
  white: string;
  black: string;
  danger: string;
  success: string;
  warning: string;
  internal: string;

  backgroundColorBody: string;
  backgroundColorPaper: string;

  textWhite: string;
  textLighter: string;
  textLight: string;
  textBase: string;
  textDark: string;
  textPrimary: string;
  textSuccess: string;
  textWarning: string;
  textDanger: string;
  textInternal: string;

  borderWhite: string;
  borderLightest: string;
  borderLighter: string;
  borderLight: string;
  borderBase: string;
  borderDark: string;
  borderDarker: string;
  borderDarkest: string;
  borderPrimary: string;
  borderSuccess: string;
  borderWarning: string;
  borderDanger: string;
  borderInternal: string;

  backgroundWhite: string;
  backgroundLightest: string;
  backgroundLighter: string;
  backgroundLight: string;
  backgroundBase: string;
  backgroundDark: string;
  backgroundDarker: string;
  backgroundDarkest: string;
  backgroundPrimary: string;
  backgroundPrimaryLight: string;
  backgroundPrimaryLighter: string;
  backgroundSuccess: string;
  backgroundWarning: string;
  backgroundDanger: string;
  backgroundDangerLighter: string;
  backgroundInternal: string;

  iconWhite: string;
  iconLighter: string;
  iconLight: string;
  iconBase: string;
  iconDark: string;
  iconPrimary: string;
  iconSuccess: string;
  iconDanger: string;
  iconWarning: string;
  iconInternal: string;
  iconGuest: string;
  iconVisit: string;

  disabled: string;
  disabledBackground: string;
}

export const themeColors = {
  light: { ...light, ...paletteColors, agGrid: agGridColors },
  dark: { ...dark, ...paletteColors, agGrid: agGridColors },
};
